import clsx from 'clsx';
import { ChevronRightIcon } from 'lucide-react';
import { EntityRecord } from '../../../../api/api-entities';
import { TableCell, TableRow } from '@@/ui/primitives';

export function EntityRow({ item, onNavigate }: { item: EntityRecord; onNavigate: (item: EntityRecord) => void }) {
  const ItemName = ({ item }: { item: EntityRecord }) => (
    <TableCell className='flex flex-col gap-1 px-3'>
      <div className='flex items-center gap-2'>
        <span className={clsx('font-semibold text-base!', 'text-slate-950')}>{item.name}</span>
      </div>
      {item.description && <p className={clsx('text-xs', 'text-slate-600 text-wrap')}>{item.description}</p>}
    </TableCell>
  );

  const ItemActions = ({ item }: { item: EntityRecord }) => (
    <TableCell>
      <div className='flex items-center gap-2 justify-end'>
        {item.childCount > 0 && (
          <span className='text-xs text-neutral-500'>
            {item.childCount} child{item.childCount > 1 ? 'ren' : ''}
          </span>
        )}
        <ChevronRightIcon className='size-4' />
      </div>
    </TableCell>
  );

  return (
    <TableRow
      className={clsx('hover:bg-slate-50/50 cursor-pointer transition-none border-b!')}
      onClick={() => onNavigate(item)}
    >
      <ItemName item={item} />
      <ItemActions item={item} />
    </TableRow>
  );
}
